import { Box, Typography } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { largeTabletAndDown } from '@/styles/media'

import { StyledSidebarMenuProps } from './types'

export const SidebarHeader = styled(Typography).attrs({
  $bold: true,
  $size: '2xl',
})``

export const SidebarContainer = styled(Box).attrs<StyledSidebarMenuProps>({
  $p: 6,
  $fullWidth: true,
})`
  position: ${({ $fixed }) => ($fixed ? 'fixed' : 'absolute')};
  top: ${({ theme, $fixed }) =>
    $fixed
      ? `calc(var(--nav-bar-height) + ${theme.space[6]})`
      : theme.space[8]};
  right: ${({ theme }) => theme.space[8]};
  max-width: 440px;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.radii.xl};
  box-shadow: ${({ theme }) => theme.shadows.sidebarRight};
  background-color: ${({ theme }) => theme.colors.surface};

  ${largeTabletAndDown(css`
    position: initial;
    border: none;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    padding: 0;
    max-width: 600px;
    margin: 0 auto;
  `)}
`
